import { BtnAccent } from '../ui/BtnAccent'
import { SectionLabel } from '../ui/SectionLabel'

const cx = 'max-w-[1100px] mx-auto px-5 sm:px-8'

export function FinalCTA() {
  return (
    <section className="py-20 sm:py-[120px] text-center border-b border-ds-border">
      <div className={cx}>
        <SectionLabel className="mb-6">Lanza tu mejor vídeo</SectionLabel>
        <h2 className="font-display font-black text-display-lg tracking-tight2 uppercase text-ds-text mb-4">
          Descubre lo
          <br />
          que <span className="italic text-ds-red">eres capaz.</span>
        </h2>
        <p className="font-sans text-[15px] text-ds-muted mb-12 leading-[1.6]">
          Gratis para siempre. Sin tarjeta. Configurado en 3 minutos.
        </p>
        <BtnAccent to="/auth" className="text-[15px] px-9 py-4">
          Crear mi cuenta gratis →
        </BtnAccent>
        <div className="flex items-center justify-center gap-6 mt-6 flex-wrap">
          {['Sin tarjeta', 'Cancela cuando quieras', 'Soporte en español'].map(t => (
            <span
              key={t}
              className="flex items-center gap-1.5 font-display font-bold text-label tracking-caption uppercase text-ds-muted"
            >
              <span className="w-1 h-1 rounded-full bg-ds-border-mid inline-block flex-shrink-0" />
              {t}
            </span>
          ))}
        </div>
      </div>
    </section>
  )
}
